import { useFeatureFlag } from '@order/LaunchDarkly';

import { USABLE_NET_BANNER_HEIGHT } from '../constants';
import { useUsableNetScrolling } from '../useUsableNetScrolling';

/**
 * Returns the offset for the usable net banner, when enabled and not scrolled.
 */
export const useUsableNetBannerOffset = () => {
  const isEnabled = useFeatureFlag('cels-3985-usable-net-enabled');
  const { isScrolled } = useUsableNetScrolling();

  return isEnabled && !isScrolled ? USABLE_NET_BANNER_HEIGHT : 0;
};
